import React from "react";

import Script from "dangerous-html/react";

import "./footer.css";

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.footer-social-item:hover, .footer-link-item:hover, .footer-submit-btn:hover, .footer-heart {
  animation: none;
  transform: none;
  transition: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <footer className="footer-wrapper">
        <div className="footer-container">
          <div className="footer-main-grid">
            <div className="footer-brand-column">
              <div className="footer-logo-group">
                <span className="footer-logo-text">MDMC</span>
                <span className="footer-logo-tagline">
                  Massive Dank Meme Collider
                </span>
              </div>
              <p className="footer-brand-description">
                Smashing memes at near-light speeds to discover the fundamental
                particles of internet humor. We don&apos;t just post; we
                accelerate.
              </p>
              <div className="footer-social-links">
                <a
                  href="https://tinyhost.xyz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div aria-label="tinyhost.xyz" className="footer-social-item">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="m14.983 3l.123.006c2.014.214 3.527.672 4.966 1.673a1 1 0 0 1 .371.488c1.876 5.315 2.373 9.987 1.451 12.28C20.891 19.452 19.288 21 17.5 21c-.732 0-1.693-.968-2.328-2.045a22 22 0 0 0 2.103-.493a1 1 0 1 0-.55-1.924c-3.32.95-6.13.95-9.45 0a1 1 0 0 0-.55 1.924q1.074.307 2.103.494C8.193 20.031 7.232 21 6.5 21c-1.788 0-3.391-1.548-4.428-3.629c-.888-2.217-.39-6.89 1.485-12.204a1 1 0 0 1 .371-.488C5.367 3.678 6.88 3.22 8.894 3.006a1 1 0 0 1 .935.435l.063.107l.651 1.285l.137-.016a13 13 0 0 1 2.643 0l.134.016l.65-1.284a1 1 0 0 1 .754-.54zM9 10a2 2 0 0 0-1.977 1.697l-.018.154L7 12l.005.15A2 2 0 1 0 9 10m6 0a2 2 0 0 0-1.977 1.697l-.018.154L13 12l.005.15A2 2 0 1 0 15 10"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a
                  href="https://tx.wtf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div aria-label="tx.wtf" className="footer-social-item">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a
                  href="https://www.janusmedia.net"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div
                    aria-label="janusmedia.net"
                    className="footer-social-item"
                  >
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M9 19c-4.3 1.4-4.3-2.5-6-3m12 5v-3.5c0-1 .1-1.4-.5-2c2.8-.3 5.5-1.4 5.5-6a4.6 4.6 0 0 0-1.3-3.2a4.2 4.2 0 0 0-.1-3.2s-1.1-.3-3.5 1.3a12.3 12.3 0 0 0-6.2 0C6.5 2.8 5.4 3.1 5.4 3.1a4.2 4.2 0 0 0-.1 3.2A4.6 4.6 0 0 0 4 9.5c0 4.6 2.7 5.7 5.5 6c-.6.6-.6 1.2-.5 2V21"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </a>
                <a
                  href="https://tx.wtf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div aria-label="tx.wtf" className="footer-social-item">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M18 3a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5zM9 9v6a1 1 0 0 0 1.514.857l5-3a1 1 0 0 0 0-1.714l-5-3A1 1 0 0 0 9 9"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-links-grid">
              <div className="footer-link-group">
                <h3 className="footer-group-title">The Collider</h3>
                <ul className="footer-link-list">
                  <li>
                    <a href="/collider">
                      <div className="footer-link-item">
                        <span>The Collider</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="/meme-generator">
                      <div className="footer-link-item">
                        <span>Meme Generator</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="/library">
                      <div className="footer-link-item">
                        <span>Dank Library</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="/output-zone">
                      <div className="footer-link-item">
                        <span>Event Horizon</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://tinyhost.xyz"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="footer-link-item">
                        <span>Host on tinyhost</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-link-group">
                <h3 className="footer-group-title">Partners</h3>
                <ul className="footer-link-list">
                  <li>
                    <a
                      href="https://tx.wtf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="footer-link-item">
                        <span>tx.wtf</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://tinyhost.xyz"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="footer-link-item">
                        <span>tinyhost.xyz</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.janusmedia.net"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="footer-link-item">
                        <span>janusmedia.net</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer-newsletter-column">
              <h3 className="footer-group-title">Join</h3>
              <p className="footer-brand-description">
                No mailing list. No loot drops. Go where the dankness lives:
                social at tx.wtf, hosting at tinyhost, applied research at
                janusmedia.net.
              </p>
              <div className="footer-social-links">
                <a
                  href="https://tx.wtf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="footer-link-item">
                    <span>Join tx.wtf</span>
                  </div>
                </a>
                <a
                  href="https://tinyhost.xyz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="footer-link-item">
                    <span>Host on tinyhost</span>
                  </div>
                </a>
                <a
                  href="https://www.janusmedia.net"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="footer-link-item">
                    <span>Applied Research</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom-bar">
            <div className="footer-legal-links">
              <a href="/legal/terms">
                <div className="footer-legal-item">
                  <span>Terms of Service</span>
                </div>
              </a>
              <a href="/legal/privacy">
                <div className="footer-legal-item">
                  <span>Privacy Policy</span>
                </div>
              </a>
            </div>
            <div className="footer-copyright">
              <span>
                {" "}
                © 2026 MDMC.dev — Accelerated with
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="footer-heart">⚡</span>
              <span>
                {" "}
                for the Dankness.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="footer-decoration-glow"></div>
      </footer>
      <div className="footer-container4">
        <div className="footer-container5">
          <Script
            html={`<style>
        @keyframes pulse {0%,100% {transform: scale(1);}
50% {transform: scale(1.2);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="footer-container6">
        <div className="footer-container7">
          <Script
            html={`<script defer data-name="footer-interactivity">
(function(){
  const footerForm = document.querySelector(".footer-newsletter-form")
  if (footerForm) {
    footerForm.addEventListener("submit", (e) => {
      const emailInput = footerForm.querySelector(".footer-email-input")
      if (emailInput.value) {
        const submitBtn = footerForm.querySelector(".footer-submit-btn")
        const originalContent = submitBtn.innerHTML

        submitBtn.innerHTML = "✨"
        submitBtn.style.backgroundColor = "var(--color-accent)"

        setTimeout(() => {
          submitBtn.innerHTML = originalContent
          submitBtn.style.backgroundColor = ""
          emailInput.value = ""
        }, 2000)
      }
    })
  }

  const socialItems = document.querySelectorAll(".footer-social-item")
  socialItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      const rotation = (Math.random() * 20 - 10).toFixed(2)
      item.style.transform = \`translateY(-4px) rotate(\${rotation}deg)\`
    })
    item.addEventListener("mouseleave", () => {
      item.style.transform = ""
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  );
};

export default Footer;
